export default __webpack_public_path__ + "static/media/comments-arrow.677ad232.svg";